import { mlflowApiClient } from '@/shared/api/core/axios-instance';

import type { UpdateModelDescriptionRequest, UpdateModelDescriptionResponse } from '@/entities/registered-model/domain';

export const updateModelDescription = async (
  request: UpdateModelDescriptionRequest
): Promise<UpdateModelDescriptionResponse> => {
  const { data } = await mlflowApiClient.patch<UpdateModelDescriptionResponse>(
    '/ajax-api/2.0/mlflow/registered-models/update',
    request
  );
  return data;
};
